export default "__VITE_ASSET__C1H6RaFs__"